import { Link } from "react-router-dom";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonType } from "components/Button/Button";
import ShareModal from "components/ShareModal/ShareModal";
import { useModal } from "components/Modal/context/ModalContext";
import { ModalButtons } from "components/Modal/ModalButtons";
import "./CourseDetails.scss";

const CourseDetails = ({ course, linkage = false }) => {
	const { openModal } = useModal();

	const getViewFullCourseLink = (course, isShareLink = false) => {
		let result = `/course-view#courseId-${course.Id}`;
		return result;
	};

	const handleOpenShareModal = ({ shareLink, contentName }) => {
		openModal("Share", <ShareModal shareLink={shareLink} contentName={contentName} />, ModalButtons.None);
	};

	const getContinueSection = () => {
		course.hasContent = course.SubContent.some((value) => value.ContentType.length);
		if (course.hasContent) {
			return (
				<div className={`list-view-item-continue ${linkage ? "" : "one-button"}`} data-test-class="course-details-continue-section">
					<p data-test-class="course-details-last-viewed">
						<strong>{course.LastViewed.Continuing ? "Last Viewed" : "Get Started"}:</strong>{" "}
						{course.LastViewed.SubContentName}
					</p>
					{linkage && (
						<Button
							to={getViewFullCourseLink(course)}
							type={ButtonType.Tertiary}
							text="View Full Course"
							scroll={true}
							data-test-class="course-details-view-button"
						/>
					)}
					<Button
						text={course.LastViewed.Continuing ? "Continue" : "Start"}
						to={`/player#courseId-${course.Id}-moduleId-${course.LastViewed.ContentId}-submoduleId-${course.LastViewed.SubContentId}`}
						glint={!course.LastViewed.Continuing}
						customClass={`${linkage ? "button-end" : ""}`}
						data-test-class="course-details-play-button"
					/>
					
				</div>
			);
		}
		return null;
	};

	const content = (
		<div className="list-view-item-details">
			<div className="list-view-item-details-text">
				{linkage ? (
					<Link to={getViewFullCourseLink(course)}>
						<h2 data-test-class="course-details-name-link">{course.Name}</h2>
					</Link>
				) : (
					<h2 data-test-class="course-details-name">{course.Name}</h2>
				)}
				<p className="list-view-item-details-text-description" data-test-class="course-details-description">{course.Description}</p>
				{getContinueSection()}
			</div>
			<div className="list-view-item-details-image">
				<div className={`list-view-item-details-links`}>
					<Button
						type={ButtonType.Tertiary}
						text="Share"
						icon={faShareNodes}
						onClick={() => handleOpenShareModal({ shareLink: getViewFullCourseLink(course, true), contentName: course.Name })}
						data-test-class="course-details-share-button"
					/>
				</div>
				{linkage ? (
					<Link to={getViewFullCourseLink(course)}>
						<img alt={course.Name} src={course.ImageUri} data-test-class="course-details-image-link" />
					</Link>
				) : (
					<img alt={course.Name} src={course.ImageUri} data-test-class="course-details-image" />
				)}
			</div>
		</div>
	);

	return <>{content}</>;
};

export default CourseDetails;
